import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
var Stepper = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className,
    children = props.children,
    active = props.active,
    label = props.label,
    status = props.status,
    trigger = props.trigger,
    hideTooltipOnBlur = props.hideTooltipOnBlur,
    restProps = props.restProps;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: className,
    style: style,
    hidden: !active,
    role: "tabpanel",
    id: "panel-" + (label ? label : ''),
    "aria-labelledby": "stepper-" + (label ? label : '')
  }, restProps), children);
});
export default Stepper;